import { PerkSource } from './Perk';

export interface VenngoRedemptionOptions {
  mobile_device: string[];
  instructions: Instructions;
  pay_methods: string[];
  serial_number: string;
  start_date: string;
  end_date: string;
  use_type: string;
  use_instruction: string;
  site_logo: string;
  logo: string;
  barcode?: Barcode[];
  coupon_code?: string;
  title: string;
  tagline: string;
  details: string;
  language_id: number;
  use_type_description: string;
  phone_number?: string;
  version: number;
  print_link: string;
  id: string;
  type: string;
  link?: string[];
  email?: string[];
}

export interface Barcode {
  barcode_url: string;
  caption: string;
}

export interface Instructions {
  '': { [key: string]: string };
  in_store: string[];
}

export interface ADRedemptionOptions {
  display: string;
  link?: string;
  promotion_code?: string;
  status: number;
  terms_of_use: string;
  phone_number: string;
  type: string;
}

export interface BaseRedemptionOptions {
  barcode?: Barcode[];
  instructions: string;
  code: string;
  termsOfUse: string;
  link?: string;
  type: RedemptionType;
  source: PerkSource;
  email?: string;
  phoneNumber?: number | string;
}

export type RedemptionOptions = VenngoRedemptionOptions | ADRedemptionOptions;

export function isVenngoRedemptionOptions(options: RedemptionOptions): options is VenngoRedemptionOptions {
  return (options as VenngoRedemptionOptions).tagline !== undefined;
}

export function isADRedemptionOptions(options: RedemptionOptions): options is ADRedemptionOptions {
  return (options as ADRedemptionOptions).display !== undefined;
}

export default RedemptionOptions;

export enum ADRedemptionType {
  InStore = 'instore',
  Online = 'online',
  Mobile = 'mobile',
}

export enum VenngoRedemptionType {
  Email = 1,
  InStore = 2,
  Mobile = 3,
  Online = 4,
}

export enum RedemptionType {
  Online = 'link',
  Phone = 'call',
  Email = 'email',
  InStore = 'instore',
}

export enum RedemptionTypeName {
  email = 1,
  instore = 2,
  mobile = 3,
  online = 4,
}
